import { useAppDispatch, useAppSelector } from 'app/store';
import {
  syncVersionEffect,
  updateReleaseVersionEffect,
} from 'app/store/Releases/effects';
import {
  getRelease,
  getReleaseVersion,
  getVersionSyncStatus,
} from 'app/store/Releases/selectors';
import { useState } from 'react';
import { ReleaseType } from 'types/releases';
import { VersionLyricsComponent } from './VersionLyricsComponent';

export const VersionLyrics = () => {
  const dispatch = useAppDispatch();
  const release = useAppSelector(getRelease);
  const version = useAppSelector(getReleaseVersion);
  const isSyncing = useAppSelector((state) =>
    getVersionSyncStatus(state, version?.song?.versionGuid as string)
  );
  const [updatingExclude, setUpdatingExclude] = useState(false);

  const handleExcludeFromRelease = async (isExcluded: boolean) => {
    if (!release || release.type === ReleaseType.LABEL) {
      return;
    }

    setUpdatingExclude(true);
    await dispatch(
      updateReleaseVersionEffect({
        formData: {
          excludeLyrics: isExcluded,
        },
        releaseType: release.type,
      })
    );
    setUpdatingExclude(false);
  };

  const handleSync = async () => {
    await dispatch(
      syncVersionEffect({
        versionGuid: version?.song.versionGuid as string,
        songGuid: version?.song.songGuid as string,
      })
    );
  };

  return (
    <VersionLyricsComponent
      onChangeExcluded={handleExcludeFromRelease}
      onSync={handleSync}
      isExcluded={Boolean(version?.lyrics?.isExcluded)}
      updatingExclude={updatingExclude}
      isSyncing={Boolean(isSyncing)}
      lyrics={version?.lyrics}
    />
  );
};
